import { useAppTheme } from '@capsicum/common';
import { useMemo } from 'react';
import { match } from 'ts-pattern';

import { FTOCardStatus } from '../models';

type FanTokenOfferingRibbonColor = {
	isFinished: boolean;
	status: FTOCardStatus;
};

export const useFanTokenOfferingRibbonColor = ({ isFinished, status }: FanTokenOfferingRibbonColor) => {
	const { theme } = useAppTheme();

	const ribbonColor = useMemo(() => {
		if (isFinished) {
			return theme.colors.backgrounds.main.subtle;
		}

		return match(status)
			.with(FTOCardStatus.PUBLISHED, () => theme.colors.backgrounds.info.subtle)
			.otherwise(() => theme.colors.backgrounds.status.availableSubtle);
	}, [isFinished, theme, status]);

	return ribbonColor;
};
